export default __webpack_public_path__ + "0cb9cc81a4a1256a96b36f0825ee5119.png";